import React from "react";
import _ from "lodash";

import {tradeNeedRiskReasoning} from "../utils";

const useRiskModal = ({handleRiskReasonChange, isAnlageberatung, clientSRI, isModelportfolio}) => {
  const [confirmRiskModalState, setConfirmRiskModalState] = React.useState({
    riskModalQueue: [],
    riskModalIndex: 0
  });

  const handleConfirmRiskModalClose = React.useCallback(() => {
    setConfirmRiskModalState({riskModalQueue: [], riskModalIndex: 0});
  }, []);

  const handleSelectAsset = React.useCallback((asset) => {
    setConfirmRiskModalState({
      riskModalQueue: [asset],
      riskModalIndex: 0
    });
  }, []);

  const onReasonSave = React.useCallback((item, value) => {
    handleRiskReasonChange(item, value)

    setConfirmRiskModalState((prevState) => {
        const nextIndex = prevState.riskModalIndex + 1;
        const hasNext = nextIndex < prevState.riskModalQueue.length;

        if (hasNext) {
          return {
            ...prevState,
            riskModalIndex: nextIndex
          };
        }

        return {
          riskModalQueue: [],
          riskModalIndex: 0
        };
      });
  }, [handleRiskReasonChange])

  const openRiskReasoningQueue = React.useCallback((assets) => {
    // Reasoning is only required for Anlageberatung with a known client risk class.
    if (!isAnlageberatung || !clientSRI) {
      return;
    }

    const pending = [];

    (assets || []).forEach((item) => {
      if (tradeNeedRiskReasoning(item, isModelportfolio, isAnlageberatung, clientSRI)) {
        pending.push(item);
      }
      });

    if (_.isEmpty(pending)) {
      return;
    }

    setConfirmRiskModalState(prevState => {
      return {
        riskModalQueue: [...prevState.riskModalQueue, ...pending],
        riskModalIndex: 0
      }
    });
  },[isModelportfolio, isAnlageberatung, clientSRI]);

  const activeAsset = confirmRiskModalState.riskModalQueue[confirmRiskModalState.riskModalIndex];

  return {
    openRiskReasoningQueue,
    riskModalProps: {
      open: !!activeAsset,
      activeAsset: activeAsset,
      onClose: handleConfirmRiskModalClose,
      onSave: onReasonSave,
      onSelectAsset: handleSelectAsset,
      queueLength: confirmRiskModalState.riskModalQueue.length,
      queueIndex: confirmRiskModalState.riskModalIndex,
    },
  }
}

export default useRiskModal;